(function() {
  'use strict';

  angular
    .module('marjakari', ['ngAnimate', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap'])
    .config(config)
    .constant('moment', moment);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();

(function() {
  'use strict';

  angular
    .module('marjakari')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController() {
      var vm = this;
      vm.isCollapsed = false;
    }
  }

})();

'use strict';

angular.module('marjakari')
  .controller('OpetusController', function () {
  });

(function() {
  'use strict';

  angular
    .module('marjakari')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {
    //var vm = this;

  }
})();

'use strict';

angular.module('marjakari')
  .controller('CvController', function () {
  });

'use strict';

angular.module('marjakari')
  .controller('ContactController', function () {
  });

(function() {
  'use strict';

  angular
    .module('marjakari')
    .config(routeConfig);

  function routeConfig($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('front', {
        url: '/',
        templateUrl: 'app/front/front.html'
      })
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController as main'
    })
      .state('cv', {
      url: '/cv',
      templateUrl: 'app/cv/cv.html',
      controller: 'CvController as cv'
    })
      .state( 'opetus', {
      url: '/opetus',
      templateUrl: 'app/opetus/opetus.html',
      controller: 'OpetusController as opetus'
    })
      .state( 'contact', {
      url: '/contact',
      templateUrl: 'app/contact/contact.html',
      controller: 'ContactController as contact'
    });
  }

})();

angular.module("marjakari").run(["$templateCache", function($templateCache) {$templateCache.put("app/contact/contact.html","<navbar></navbar><div class=container><div class=row><div class=\"col-md-5 col-lg-5 box\"><h1>Yhteystiedot</h1><p>info@marjakari.com</p><p>Puh. 044 755 6000</p><p>Y-tunnus 2673248-8</p></div></div></div>");
$templateCache.put("app/cv/cv.html","<navbar></navbar><div class=container><div class=row><div class=\"col-md-8 col-lg-8 box\"><h1>CV</h1><p><b>Musiikkikoulutus</b><ul><li>2011-2015, Musiikkipedagogi (AMK), laulu, Metropolia ammattikorkeakoulu, opettajina Sirkka Parviainen ja Monika Hauswalter</li><li>Opiskelijavaihto, Hochschule für Musik und Theater Hamburg, kevät 2014, opettaja Prof. Geert Smits</li><li>2003-2006, Muusikko, pääinstrumentti piano, sivuinstrumentti laulu, Helsingin konservatorio</li><li>Ennen ammattiopintoja lauluopettajana Anitta Ranta.</li><li>Täydentäviä yksityisiä lauluopintoja Raissa Palmun, Cynthia Makrisin, Janet Williamsin (Berliini) ja Ashley Staffordin (Lontoo) johdolla.</li><li>Mestarikursseja mm. Cynthia Makris, Johanna Rusanen-Kartano, Björn Blomqvist, Sirkku Wahlroos-Kaitila, Christian Juslin, Mika Kares, Csilla Boross, Franz Lukasowsky</li><li>Lied-opintoja Heikki Pellisen, Juho Alakärpän ja Pia Värrin johdolla</li></ul><b>Oopperaroolit</b><ul><li>R. Strauss, Arabella, Adelaide (Mutter)</li><li>R. Wagner, Parsifal, 3. Blumenmädchen</li><li>P. Rosato, Lars Cleen – Lo straniero, Venerina (kantaesitys)</li><li>R. Wagner, Die Walküre, Waltraute</li><li>R. Wagner, Das Rheingold, Wellgunde</li><li>W.A. Mozart, Die Zauberflöte, 2. Dame</li><li>I. Kuusisto, Miehen kylkiluu, Amalia</li></ul><b>Keskeisiä sooloesiintymisiä</b><ul><li>Ensikonsertti Mielen pimeät puolet 19.3.2017</li><li>Sooloresitaali Mielen pimeät puolet -ohjelmalla 16.8.2017 Oulun Tulindberg-salissa</li><li>Töölö Brassin joulukonserttien solistina 12/2016</li><li>Helsinginkadun filharmonikkojen Valkyyriat ja Planeetat -konsertin solistina 2 / 2016</li></ul><b>Oopperakuorokokemus</b><ul><li>Kansallisooppera, lisäkuoro, Nürnbergin mestarilaulajat 2015</li><li>Savonlinnan oopperajuhlakuoro, kaudet 2013 ja 2015</li><li>Savonlinnan oopperajuhlakuoro, vierailuesitykset Hong Kong Arts Festivalilla 2014</li></ul></p></div></div></div>");
$templateCache.put("app/front/front.html","<div><navbar></navbar></div><div class=container><div class=row><div class=\"col-lg-5 box opaque\"><h1 class=specialheading>Marja Kari</h1><h2>Dramaattinen sopraano</h2></div></div></div>");
$templateCache.put("app/main/main.html","<navbar></navbar><div class=container><div class=row><div class=\"col-md-8 col-lg-8 box\"><h1>Marja Kari</h1><p>Olen dramaattinen sopraano ja ääntäni on luonnehdittu muun muassa suureksi, täyteläiseksi ja ilmaisuvoimaiseksi.</p><p>Olen esittänyt monen aikakauden ja tyylin musiikkia barokista nykymusiikkiin. Erityinen kiinnostuksen kohteeni on Richard Wagnerin musiikki. Juuri Wagnerin musiikkia laulamalla löysin ensimmäiset aavistukset siitä, mitä ääneni voisi olla. Sen lisäksi että ääneni soveltuu moniin Wagnerin kirjoittamiin rooleihin, hänen musiikkinsa on loputon monikerroksinen aarrearkku, joka tuntuu toimivan kuulijoille alitajunnankin tasolla.</p><p>Kesästä 2017 lähtien olen ollut mukana uudessa Improvisaatioteatteri Pääskyt -ryhmässä, joka esiintyy pääasiassa Helsingin Kallion alueella. Esityksiin kuuluu sekä perinteisiä teatteri-improvisaatiotekniikoita että improvisoituja laulunumeroita.</p>Olen aloittanut musiikkiopintoni pianistina, mutta laulusta löysin omimman instrumenttini. Laulumusiikin ja erityisesti oopperan parissa pääsen toteuttamaan jo lapsuudessa alkanutta kiinnostusta teatteriin, heittäytymään eri hahmojen nahkoihin ja elämään eri elämiä mielikuvituksessa. Jotain omaa, jotain lainattua, jotain varastettua.<p></p></div></div></div>");
$templateCache.put("app/opetus/opetus.html","<navbar></navbar><div class=container><div class=row><div class=\"col-md-8 col-lg-8 box\"><h1>Laulunopetus</h1><p>Opetan laulua yksityisesti. Olen toiminut myös tuntiopettajana Helsingin kaupungin työväenopistossa (äitiysloman sijaisuus) yksinlaulukursseilla sekä ooppera-ensemble -kurssilla.</p><p>Laulun ilo kuuluu kaikille. Laulaminen on opittava taito, jossa kuka tahansa voi kehittyä omista lähtökohdistaan. Äänen laatuun ja hallintaan voi vaikuttaa, ja usein niin sanottu laulutaidottomuus johtuu siitä, että ei ole tottunut käyttämään ääntään. Äänenkäytössä olevat vaikeudet voivat johtua esimerkiksi erilaisista jännityksistä kehossa, jotka haittaavat äänen vapaata toimintaa. Kun kehoaan ja ääntään oppii pikkuhiljaa tuntemaan ja käyttämään oikealla tavalla äänenkäyttöön liittyviä kehon osia, laulaminen helpottuu.</p><p>Olen itse ryhtynyt laulamaan vasta aikuisiällä. Kun säestin laulajia piano-opintojeni aikana, innostuin kokeilemaan itsekin ja hakeuduin laulutunneille. Omaa laulajan taivaltani kuvaa hyvin lainaus \"tahto rautainen vie läpi harmaan kallion\". Olen rakentanut instrumenttini ammattitasolle sitkeällä harjoittelulla, perehtymällä äänen toimintaan ja hyvien opettajien opastuksella. Tämä antaa minulle hyvän pohjan myös muiden opettamiseen ja omakohtaista perspektiiviä aloittelijan haasteisiin.</p><p>Ääni on hyvin henkilökohtainen instrumentti ja siksi pyrin luomaan laulutunnille kannustavan ja rakentavan ilmapiirin, jossa on turvallista kokeilla ja oppia. Pyrin ohjaamaan oppilaita oman äänensä löytämiseen ja tutkiskeluun. Tavoite olisi se, että oppi ei jää vain tunnille vaan laulua harrastava oppilas osaa myös itsekseen laulaessaan lämmitellä sopivilla harjoituksilla, hakea oikeita tuntemuksia ja saada äänensä toimimaan.</p><p>Vaikka toimivasta äänestä on iloa muutenkin, laulun opettelun tarkoitus on päästä musisoimaan. Koska olen myös pianisti, laulutunneillani pääsee laulamaan lauluja säestyksen kanssa.</p><p>Olen kouluttautunut nimenomaan klassisen laulun opetukseen. Perusasioita äänenkäytöstä, oman soivan perusäänen löytämistä ja musiikillista ilmaisua voin opettaa genrestä riippumatta. Olen itse laulanut myös kevyempää musiikkia aiemman bändiharrastuksen puitteissa.</p><p>Minulla on opetustilat Helsingissä Vaasankadulla ja Lapinlahdessa (Lapinlahdenpolku 1)</p></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=header><nav class=\"navbar navbar-default\" role=navigation><div class=container><div class=navbar-header><button type=button class=navbar-toggle ng-click=\"isCollapsed = !isCollapsed\"><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=front>Marja Kari</a></div><div class=\"collapse navbar-collapse\" uib-collapse=isCollapsed><ul class=\"nav navbar-nav\"><li ui-sref-active=active><a ui-sref=main>Minusta</a></li><li ui-sref-active=active><a ui-sref=cv>CV</a></li><li ui-sref-active=active><a ui-sref=opetus>Opetus</a></li><li ui-sref-active=active><a ui-sref=contact>Yhteystiedot</a></li></ul><!--<ul class=\"nav navbar-nav navbar-right\">\n          <li><a href=\"#\">Suomeksi</a></li>\n          <li><a href=\"#\">English</a></li>\n        </ul>--></div></div></nav></div>");}]);